<template>
  <div :class="$style.header">
    <div :class="$style.darkBackground"></div>
    <div :class="$style.main">
      <div :class="$style.brand">
        <h1>Proof Admin</h1>
      </div>
      <Nav v-if="!nav" />
    </div>
  </div>
</template>

<script>
  import Nav from './Nav'
  export default {
    name: 'Header',
    components: {
      Nav
    },
    props: ['nav', 'center']
  }
</script>

<style lang="scss" module>
  .header {
    padding-top: 10px;
    .darkBackground {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 260px;
      background-color: #0d1e25;
      z-index: -1;
    }
    .main {
      position: relative;
      z-index: 1;
      .brand {
        font-size: 14px;
        color: white;
        padding: 10px 10px 15px;
        line-height: 1em;
        &.center {
          text-align: center
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/lib/Header/index.vue